const INTERNAL_EMAIL_DOMAIN = '@cube.asia';

export const isInternalUserEmail = (email?: string | null) =>
  email?.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN) ?? false;
